import { Component, OnInit } from '@angular/core';
import { NoticeController } from '@shared/src/controllers/notice/notice.controller';
import { NoticeViewDto, NoticeViewQuestionDto } from '@shared/src/dtos/notice/NoticeViewDto';

/***
 * Històric dels avisos que l'usuari ja ha llegit, amb les respostes que va donar.
 */
@Component({
    selector: 'shared-notice-read-component',
    templateUrl: './shared.notice.read.component.html',
    styleUrls: ['./shared.notice.read.component.scss'],
})
export class SharedNoticeReadComponent implements OnInit {

    public notices: NoticeViewDto[] = [];
    public expanded: number = null;

    constructor(protected noticeController: NoticeController) { }

    ngOnInit(): void {
        this.noticeController.getRead().subscribe(data => this.notices = data != null ? data : []);
    }

    public isExpanded(notice: NoticeViewDto): boolean {
        return this.expanded === notice.noticeId;
    }

    public toggle(notice: NoticeViewDto): void {
        this.expanded = this.isExpanded(notice) ? null : notice.noticeId;
    }

    public answerLabel(question: NoticeViewQuestionDto): string {
        if (question.answer == null)
            return '';
        return question.answer ? question.yesLabel : question.noLabel;
    }
}
